export default __webpack_public_path__ + "static/media/signin-background.533a2225.jpeg";